module.exports = __webpack_public_path__ + "img/Finastra_Exit_Logo.315363ab.png";